export const selectCurrentUserAppointments = state => state.appointment.appointments;

export const selectAppointment = state => state.appointment.appointment;
